import { cva, RecipeVariantProps } from '@allenai/varnish-panda-runtime/css';

const descriptionRecipe = cva({
    base: {
        display: 'block',
        color: 'text',
        _groupDisabled: {
            color: 'text.disabled',
        },
    },
    variants: {
        size: {
            small: {
                fontSize: '[12px]',
            },
            medium: {
                fontSize: 'sm',
            },
            large: {
                fontSize: 'md',
            },
        },
    },
    defaultVariants: {
        size: 'medium',
    },
});

type DescriptionRecipeProps = RecipeVariantProps<typeof descriptionRecipe>;

export { descriptionRecipe, descriptionRecipe as default };
export type { DescriptionRecipeProps };
